module.exports = __webpack_public_path__ + "static/img/illustratepic_02.d27bc13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zh-TW/illustratepic_02.png
// module id = oQbI
// module chunks = 1